export const TERMS_ACTION_START = 'TERMS_ACTION_START';
export const TERMS_ACTION_ERROR = 'TERMS_ACTION_ERROR';
export const GET_ALL_TERMS = 'GET_ALL_TERMS';
export const GET_TERMS = 'GET_TERMS';
export const CREATE_TERMS = 'CREATE_TERMS';
export const EXPIRE_TERMS = 'EXPIRE_TERMS';
export const ACTIVATE_TERMS = 'ACTIVATE_TERMS';

export const termsActionStart = () => ({ type: TERMS_ACTION_START });
export const termsActionError = (error: any) => ({ type: TERMS_ACTION_ERROR, payload: error });
export const getAllTermsAction = (terms: any[]) => ({ type: GET_ALL_TERMS, payload: terms });
export const getTermsAction = (terms: any) => ({ type: GET_TERMS, payload: terms });
export const createTermsAction = (terms: any) => ({ type: CREATE_TERMS, payload: terms });
export const expireTermsAction = (termsId: string) => ({ type: EXPIRE_TERMS, payload: termsId });
export const activateTermsAction = (termsId: string) => ({ type: ACTIVATE_TERMS, payload: termsId }); 